import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Spinner } from "react-bootstrap";
import { fetchDirectorProfileApi, fetchPublicAppliedRoleListApi } from "../../services/api";

import ModernAuditionCard from "../../components/ModernAuditionCard";
import { TalentAuditionCard } from "../dashboard/TalentAuditionCard";

import "./CastingDirectorProfile.css";

const CastingDirectorProfile = () => {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [appliedData, setAppliedData] = useState([]); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAllData();
  }, [id]);

  const loadAllData = async () => {
    try {
      setLoading(true);
      const resProfile = await fetchDirectorProfileApi(id);
      const resApplied = await fetchPublicAppliedRoleListApi(id);

      if (resProfile?.data?.success) setProfile(resProfile.data.data);
      if (resApplied?.data?.success) setAppliedData(resApplied.data.data || []);
    } catch (err) {
      console.error("Error loading data:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatOngoingData = (project, matchedRole) => ({
    id: matchedRole?.id || project?.id,
    jogetRoleId: matchedRole?.joget_role_id || matchedRole?.id,
    urlSlug: matchedRole?.urlSlug || project?.project_name?.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
    projectName: project?.project_name || "Project",
    roleTitle: matchedRole?.role_name || "View Roles",
    roleCategory: project?.project_type || "Production",
    projectImageUrl: project?.project_image || "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba",
    auditionType: matchedRole?.audition_type || matchedRole?.auditionType || "Hindi",
    roleCost: { totalAmount: project?.final_amount || matchedRole?.final_amount || 0 },
    finalAmount: project?.final_amount || matchedRole?.final_amount || 0
  });

  if (loading) {
    return (
      <div className="cdp-loading-wrap">
        <Spinner animation="border" variant="danger" />
        <p className="mt-3 text-white">Loading Profile...</p>
      </div>
    );
  }

  const selectedAuditions = appliedData.filter(item => (item.result || "").toUpperCase() === "SELECTED");
  const ongoingProjects = profile?.projects || [];

  return (
    <div className="cdp-page">
      <Container fluid className="px-3 px-md-5">

        {/* HEADER SECTION */}
        <div className="cdp-header">
          <img
            src={profile?.profile_image_url || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
            alt={profile?.full_name}
            className="cdp-image"
          />
          <div className="cdp-info">
            <h1>{profile?.full_name}</h1>
            <h3>
              {(profile?.specialization || "castingDirector")
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase())}
            </h3>
            <p className="cdp-about">{profile?.about_agency}</p>
          </div>
        </div>

        {/* SECTION 1: ONGOING PROJECTS (HORIZONTAL SCROLL) */}
        <div className="cdp-section mt-5">
          <h2 className="cdp-section-title">
            ONGOING <span>PROJECTS</span>
          </h2>
          <div className="cdp-scroll-wrapper mt-4">
            {ongoingProjects.length > 0 ? (
              ongoingProjects.map((project) => {
                const matchedRole = profile?.roles?.find(r => r.project_joget_id === project.joget_project_id);
                return (
                  <div className="cdp-scroll-item" key={`ong-${project.id}`}>
                    <ModernAuditionCard audition={formatOngoingData(project, matchedRole)} />
                  </div>
                );
              })
            ) : (
              <p className="text-white-50">No ongoing projects found.</p>
            )}
          </div>
        </div>

        {/* SECTION 2: SELECTED AUDITIONS (HORIZONTAL SCROLL) */}
        {selectedAuditions.length > 0 && (
          <div className="cdp-section mt-5 pt-4 border-top border-dark">
            <h2 className="cdp-section-title">
              SELECTED <span>AUDITIONS</span>
            </h2>
            <div className="cdp-scroll-wrapper mt-4">
              {selectedAuditions.map((item) => (
                <div className="cdp-scroll-item" key={`sel-${item.roleApplicationId}`}>
                  <TalentAuditionCard audition={item} />
                </div>
              ))}
            </div>
          </div>
        )}

      </Container>
    </div>
  );
};

export default CastingDirectorProfile;